import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import { Endpoint } from '@business/api/endpoint';
import { initBlocs } from '@business/blocs';
import { registerBlocs } from '@business/blocs/register';
import { CommonService } from '@business/services';
import { AppConfig } from '@core/utils/config';
import { R } from '@core/utils/r';
import { ignoreError } from '@core/utils/rxjs/operators';
import { Session } from '@modules/auth/session';
import React from 'react';
import { finalize, tap, switchMap } from 'rxjs/operators';
import App from './App';
import { createRoot } from 'react-dom/client';
import ReactGA from 'react-ga4';
import { Config } from '@config';

export function boot() {
  registerBlocs();

  initializeAppId();

  restoreSession();

  Bugsnag.start({
    apiKey: 'c604c2d787391de9083aade4634ef780',
    plugins: [new BugsnagPluginReact()],
    autoDetectErrors: false,
    autoTrackSessions: false,
    onError: function (event) {
      if (Session.user) {
        event.setUser(Session.user.id, Session.user.email, CommonService.getFullName(Session.user));
      }
      event.addMetadata('company', {
        appId: AppConfig.current().appId,
        companyId: AppConfig.current().companyId,
      });
    },
  });
}

try {
  const isDev = Config.BUILD_MODE === 'dev';
  const propertyId = isDev ? 'G-2B09DCRYSQ' : 'G-KHXRX76FT1';
  ReactGA.initialize(propertyId, {
    gtagOptions: {
      debug_mode: isDev,
    },
  });
} catch (error) {
  console.error('GA4 Initialization Error:', error);
}

function renderApp() {
  const root = createRoot(document.getElementById('root'));

  root.render(<App />);
}

function restoreSession() {
  Session.restore(AppConfig.current().companyId).pipe(tap(initBlocs), ignoreError(), finalize(renderApp)).subscribe();
}

export function initializeAppId() {
  let appId = document.querySelector("meta[name='tenant']")!.getAttribute('content');
  const config = AppConfig.get();
  if (R.isEmpty(appId)) {
    appId = config.appId || '';
  }
  AppConfig.set({ appId });
  Endpoint.setAppId(appId);
  Endpoint.setCompanyId(config.companyId);
}
